export enum CashRequestStatus {
  AVAILABLE = "Disponible",
  TO_PROCESS = "A procesar",
  NEEDS_INFO = "Requiere informacion",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
}

export enum CheckRequestStatus {
  AVAILABLE = "Disponible",
  TO_PROCESS = "A procesar",
  NEEDS_INFO = "Requiere informacion",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
}

export enum TransferRequestStatus {
  PENDING = "En curso",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  FAILED = "Fallida",
}

export enum ScheduledTransferStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  ON_REVISION = "En revision",
  FAILED = "Fallida",
  SCHEDULED = "Programada",
}

export enum SellOrderStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  TO_PROCESS = "A procesar",
}

export enum CounterDeliveryStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  TO_PROCESS = "A procesar",
  IN_NEGOTIATION = "En negociacion",
}

export enum RequestTypes {
  CASH = 1,
  PHYSICAL_CHECK = 2,
  E_CHEQ = 3,
}

export enum RequestTypeDescription {
  CASH = "Efectivo",
  PHYSICAL_CHECK = "Cheque Físico",
  E_CHEQ = "E-Cheq",
}

export enum ContactRequestStatus {
  PENDING = 1,
  CONTACTED = 2,
}
